{
  "version": 1,
  "asset_id": "0faa8f96-ca09-48cc-8197-ea862559dbc3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0faa8f96-ca09-48cc-8197-ea862559dbc3/hiatal-type-1-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0faa8f96-ca09-48cc-8197-ea862559dbc3/hiatal-type-1-1200.webp",
  "original_filename": "hiatal-type-1-1200.webp",
  "size": 165538,
  "content_type": "image/webp",
  "created_at": "2026-09-24T19:21:24Z"
}
